import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient, InMemoryCache } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'
import store from '@/store'
// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN || 'apollo-token'


// Call this in the Vue app file
export function createProvider () {

  // Create the upload link
  const uploadLink = createUploadLink({
    uri: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:3004/graphql',
  });

  // Create the auth link that adds headers including the authorization token
  const authLink = setContext((_, { headers }) => {
    // Get the authentication token from local storage if it exists
    const token = localStorage.getItem(AUTH_TOKEN);
    
    return {
      headers: {
        ...headers,
        'ato-origin': 'cms',
        ...(token ? { authorization: `Bearer ${token}` } : {}),
      },
    };
  });

  // Combine auth and upload links
  const link = authLink.concat(uploadLink);

  // Create Apollo Client directly without the helper
  const apolloClient = new ApolloClient({
    link: link,
    cache: new InMemoryCache({
      addTypename: false
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  })

  apolloClient.wsClient = null

  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    errorHandler (error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })
  store.commit('SET_APOLLO_PROVIDER', apolloProvider)

  return apolloProvider
}

export async function onLogin (apolloClient, token) {
  console.log("ON LOGIN");
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  console.log("APOLLOCLIENT", apolloClient);
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

export async function onLogout (apolloClient) {
  console.log("ON LOGOUT");
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
  }
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
